import React, { useEffect, useState } from "react";

const cardsArray = [
  "🍎","🍌","🍇","🍉",
  "🍓","🍒","🥝","🍍",
  "🍎","🍌","🍇","🍉",
  "🍓","🍒","🥝","🍍"
];


function Game({ user }) {
  const [cards, setCards] = useState([]);
  const [first, setFirst] = useState(null);
  const [second, setSecond] = useState(null);
  const [moves, setMoves] = useState(0);
  const [time, setTime] = useState(0);
  const [matched, setMatched] = useState([]);

  // shuffle cards
  useEffect(() => {
    const shuffled = [...cardsArray].sort(() => Math.random() - 0.5);
    setCards(shuffled);
  }, []);

  // timer
  useEffect(() => {
    const timer = setInterval(() => {
      setTime((t) => t + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // matching logic
 useEffect(() => {
  if (first !== null && second !== null) {
    if (cards[first] === cards[second]) {
      setMatched((prev) => [...prev, first, second]);
      resetTurn();
    } else {
      setTimeout(resetTurn, 800);
    }
    setMoves((m) => m + 1);
  }
}, [second, first, cards]);

  const handleFlip = (index) => {
    if (first === null) {
      setFirst(index);
    } else if (first !== index && second === null) {
      setSecond(index);
    }
  };

  const resetTurn = () => {
    setFirst(null);
    setSecond(null);
  };

  return (
    <>
      {/* INFO */}
      <p className="info">
        Moves: {moves} | Time: {time}s
      </p>

      {/* GRID */}
      <div className="grid-container">
        {cards.map((card, index) => {
          const isFlipped =
            index === first ||
            index === second ||
            matched.includes(index);

          return (
            <div
              key={index}
              className={`card ${isFlipped ? "flipped" : ""}`}
              onClick={() => handleFlip(index)}
            >
              <div className="front">
                {card}
              </div>
              <div className="back"></div>
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Game;
